import React, { useState } from "react";
import DataTable from "../../Robuts Components/DataTable";
import { Modal, Button, Spinner } from "react-bootstrap";
import { IoReturnDownForward } from "react-icons/io5";
import {
  reactivateStudent,
  deleteStudent,
} from "../../../../backend/firebaseFunctions";

function ArchiveStudentsPane({
  students,
  groups,
  setCurrentTab,
  userID,
  activateAlert,
}) {
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showStudentReactivateModal, setShowStudentReactivateModal] =
    useState(false);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);
  const [isReactivating, setIsReactivating] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const onArchivedStudentRowClick = (student) => {
    setSelectedStudent(student);
    setShowStudentReactivateModal(true);
  };

  const handleReactivateStudent = async () => {
    setIsReactivating(true);
    try {
      const isStudentReactivated = await reactivateStudent(
        userID,
        selectedStudent.id
      );
      if (isStudentReactivated) {
        activateAlert("success", "אליפות!", "החניך הופעל מחדש במערכת");
        // Don't update local state - let the real-time listener handle it
      }
    } catch (error) {
      activateAlert(
        "danger",
        "שגיאה!",
        "לא הצלחנו להפעיל מחדש את החניך, נסה שוב"
      );
    }
    setIsReactivating(false);
    setShowStudentReactivateModal(false);
  };

  const handleDeleteStudent = async () => {
    setIsDeleting(true);
    try {
      const isStudentDeleted = await deleteStudent(userID, selectedStudent.id);
      if (isStudentDeleted) {
        activateAlert("success", "אליפות!", "החניך נמחק מהמערכת");
        // Don't update local state - let the real-time listener handle it
      }
    } catch (error) {
      activateAlert("danger", "שגיאה!", "לא הצלחנו למחוק את החניך, נסה שוב");
    }
    setIsDeleting(false);
    setShowStudentReactivateModal(false);
    setShowDeleteConfirmationModal(false);
  };

  // Filter only archived students
  const archivedStudents =
    students?.filter((student) => student?.status === "not active") || [];

  // Helper to generate displayGroups like in StudentsPane.js
  const getDisplayGroups = (student) => {
    if (!student.groupsIDs || !groups) return "-";
    const ids = Array.isArray(student.groupsIDs)
      ? student.groupsIDs
      : [student.groupsIDs];
    const groupNames = ids
      .map((id) => {
        const group = groups.find((g) => g.id === id);
        return group
          ? `${group.name}${group.dojo ? `, ${group.dojo}` : ""}`
          : null;
      })
      .filter(Boolean);
    return groupNames.length > 0 ? groupNames.join(", ") : "-";
  };

  // Add displayGroups to each archived student
  const archivedStudentsWithDisplayGroups = archivedStudents.map((student) => ({
    ...student,
    displayGroups: getDisplayGroups(student),
  }));

  // Modern design styles
  const mainBg = {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #f8fafc 0%, #e3e9f7 100%)",
    padding: "32px 0",
  };
  const containerStyle = {
    maxWidth: 1200,
    margin: "0 auto",
    padding: "0 16px",
  };
  const headerStyle = {
    fontWeight: 800,
    fontSize: "2.5rem",
    letterSpacing: 1,
    marginBottom: 24,
    textAlign: "center",
  };
  const sectionCardStyle = {
    marginBottom: 40,
    background: "#fff",
    borderRadius: 18,
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    padding: 24,
    direction: "ltr",
  };
  const backButtonStyle = {
    fontWeight: 700,
    fontSize: "1.2rem",
    borderRadius: 999,
    padding: "12px 32px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    marginBottom: 32,
  };
  // Modern empty state
  const hasAnyArchivedStudents =
    archivedStudentsWithDisplayGroups &&
    archivedStudentsWithDisplayGroups.length > 0;

  return (
    <div style={mainBg}>
      <style>{`
        .modern-student-card {
          border-radius: 16px !important;
          box-shadow: 0 2px 12px rgba(0,0,0,0.06) !important;
          background: #fff !important;
          transition: box-shadow 0.2s, transform 0.2s;
        }
        .modern-student-card:hover {
          box-shadow: 0 4px 24px #1976d233 !important;
          transform: translateY(-2px) scale(1.01);
        }
        .modern-section-header-icon {
          font-size: 1.3em;
          margin-left: 8px;
        }
        .modern-back-btn {
          border-radius: 999px !important;
          font-weight: 700 !important;
          font-size: 1.2rem !important;
          padding: 12px 32px !important;
          box-shadow: 0 2px 8px rgba(0,0,0,0.08) !important;
        }
        .modern-modal .modal-content {
          border-radius: 18px !important;
          background: #f8fafc !important;
        }
        .modern-modal .modal-header {
          border-radius: 18px 18px 0 0 !important;
        }
        .modern-modal .modal-footer {
          border-radius: 0 0 18px 18px !important;
        }
        .modern-form-input, .modern-form-input:focus {
          border-radius: 10px !important;
          box-shadow: 0 1px 4px rgba(0,0,0,0.04) !important;
          border: 1px solid #e0e0e0 !important;
          background: #fff !important;
        }
        .modern-students-table {
          border-radius: 16px !important;
          box-shadow: 0 2px 12px rgba(0,0,0,0.06) !important;
          background: #fff !important;
          padding: 16px;
        }
      `}</style>
      <div style={containerStyle}>
        <h1 style={headerStyle}>ארכיון ספורטאים</h1>
        <div style={{ textAlign: "flex-end", margin: 0, padding: 0, justifyContent: "flex-end", alignItems: "flex-end", display: "flex", flexDirection: "row", justifyItems: "flex-end", width: "100%" }}>
          <Button
            variant="secondary"
            onClick={() => setCurrentTab("students")}
            className="modern-back-btn"
            style={backButtonStyle}
          >
            חזור
            <IoReturnDownForward size={24} style={{ marginLeft: "2vh" }} />
          </Button>
        </div>
        <p style={{ textAlign: "center" }}>
          לחץ על החניך בכדי להפעיל אותו מחדש או למחוק אותו
        </p>
        {/* Modern empty state if no archived students */}
        {!hasAnyArchivedStudents && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: 320,
              color: "#888",
              fontWeight: 600,
              fontSize: "1.3rem",
              background: "#fff",
              borderRadius: 18,
              boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
              margin: "48px auto 0 auto",
              maxWidth: 500,
              padding: 48,
              direction: "rtl",
            }}
          >
            אין ספורטאים בארכיון כרגע.
          </div>
        )}
        {/* Students Table Section */}
        {hasAnyArchivedStudents && (
          <div style={sectionCardStyle} className="modern-student-card">
            <div
              style={{
                fontWeight: 700,
                fontSize: "1.4rem",
                color: "#1976d2",
                borderRight: "6px solid #1976d2",
                paddingRight: 16,
                marginBottom: 24,
                display: "flex",
                alignItems: "center",
                gap: 10,
                direction: "rtl",
              }}
            >
              <IoReturnDownForward className="modern-section-header-icon" />
              כל הספורטאים בארכיון
            </div>
            <div className="modern-students-table">
              <DataTable
                messageIfEmpty="אין ספורטאים בארכיון"
                data={archivedStudentsWithDisplayGroups}
                type="archivedstudents"
                style={{ width: "100%" }}
                columnMapping={{
                  address: "כתובת",
                  age: "גיל",
                  gender: "מין",
                  name: "שם החניך",
                  displayGroups: "קבוצות",
                }}
                ignoredAttributes={[
                  "id",
                  "studentCreatedAt",
                  "beltColor",
                  "beltLevel",
                  "birthday",
                  "classPresenceRecords",
                  "firstParentEmailAddress",
                  "firstParentName",
                  "firstParentNumber",
                  "imageURI",
                  "imageUploadTime",
                  "specialFields",
                  "status",
                  "weight",
                  "weightKG",
                  "secondParentEmailAddress",
                  "secondParentName",
                  "secondParentNumber",
                  "momPhoneNumber",
                  "momEmailAddress",
                  "momName",
                  "IDnumber",
                  "studentID",
                  "studentCreatedTime",
                  "studentSource",
                  "createdAt",
                  "shortsSize",
                  "pantsSize",
                  "paymentCheckData",
                  "groupsIDs",
                  "formattedCreatedAt",
                ]}
                onRowClick={onArchivedStudentRowClick}
                metaData={groups || []}
              />
            </div>
          </div>
        )}
        <Modal
          show={showStudentReactivateModal}
          onHide={() => {
            setShowStudentReactivateModal(false);
          }}
          className="modern-modal"
        >
          <Modal.Header className="hebrewHeader">
            <Modal.Title className="hebrewText">
              פעולות חניך - {selectedStudent?.name}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="hebrewText">מה תרצה לעשות עם חניך זה?</p>
            <p className="hebrewText">
              הפעלה מחדש תאפשר לחניך להתחבר למערכת ולצפות במידע שלו
            </p>
            <p className="hebrewText" style={{ color: "red" }}>
              מחיקה תמחק את החניך לחלוטין מהמערכת
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="danger"
              onClick={() => {
                setShowStudentReactivateModal(false);
                setShowDeleteConfirmationModal(true);
              }}
              disabled={isReactivating || isDeleting}
            >
              מחק את החניך
            </Button>
            <Button
              variant="success"
              onClick={handleReactivateStudent}
              disabled={isReactivating || isDeleting}
            >
              {isReactivating ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    style={{ marginLeft: "8px" }}
                  />
                  מפעיל מחדש...
                </>
              ) : (
                "הפעל מחדש את החניך"
              )}
            </Button>
            <Button
              variant="secondary"
              onClick={() => {
                setShowStudentReactivateModal(false);
              }}
              disabled={isReactivating || isDeleting}
            >
              ביטול
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Delete Confirmation Modal */}
        <Modal
          show={showDeleteConfirmationModal}
          onHide={() => setShowDeleteConfirmationModal(false)}
          className="modern-modal"
        >
          <Modal.Header className="hebrewHeader">
            <Modal.Title className="hebrewText">
              אישור מחיקה - {selectedStudent?.name}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="hebrewText">האם אתה בטוח שברצונך למחוק את החניך?</p>
            <p className="hebrewText" style={{ color: "red" }}>
              פעולה זו אינה ניתנת לביטול, החניך יימחק מהמערכת ולא יהיה ניתן
              לשחזר את המידע לגביו
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="danger"
              onClick={handleDeleteStudent}
              disabled={isDeleting}
            >
              {isDeleting ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    style={{ marginLeft: "8px" }}
                  />
                  מוחק...
                </>
              ) : (
                "מחק את החניך"
              )}
            </Button>
            <Button
              variant="secondary"
              onClick={() => {
                setShowDeleteConfirmationModal(false);
                setShowStudentReactivateModal(true);
              }}
              disabled={isDeleting}
            >
              ביטול
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}

export default ArchiveStudentsPane;
